import { CATEGORIES } from "~/constants/category"

export function getCategoryById(id: string): Category | null {
  return CATEGORIES.find(category => category.id === id) || null
}

export function getCategoryByV4Id(v4Id: number): Category | null {
  return CATEGORIES.find(category => category.v4Id === v4Id) || null
}
